type NamedItem = {
  simple_name?: string | null;
  clean_name?: string | null;
  description: string;
};

/**
 * Human-readable name for an inventory item: the clean `simple_name`, falling
 * back to the AI `clean_name`, then the raw supplier `description`. Single
 * source of truth for how an item is labelled across the app — the catalogue
 * pages, waste pickers, recipe ingredient lists, and the Stock page.
 */
export function itemDisplayName(item: NamedItem): string {
  return item.simple_name || item.clean_name || item.description;
}
